import { render, staticRenderFns } from "./GamiCollections.vue?vue&type=template&id=6eb554de&scoped=true"
import script from "./GamiCollections.vue?vue&type=script&lang=js"
export * from "./GamiCollections.vue?vue&type=script&lang=js"
import style0 from "./GamiCollections.vue?vue&type=style&index=0&id=6eb554de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb554de",
  null
  
)

export default component.exports